import { WarningOutlined } from '@ant-design/icons';
import { Col, Form, Modal, Row } from 'antd';
import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import {
  AddUserFormInterface,
  EditUserFormInterface,
} from '../../../constants/types';
import theme from '../../../styles/theme';
import { getParentOrigin } from '../../../utils/getKeycloakConfig';
import UserForm from './UserForm';

interface Props {
  onSubmit: Function;
}

const AddUserForm: FC<Props> = ({ onSubmit }) => {
  const [form] = Form.useForm<AddUserFormInterface>();
  const history = useHistory();
  const parentOrigin = getParentOrigin();
  const { getFieldValue } = form;
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [warningModalShown, setWarningModalShown] = useState(false);

  const onFinish = async (
    values: AddUserFormInterface | EditUserFormInterface,
  ) => {
    const formValue = values as AddUserFormInterface;
    const userDetails: any = {
      firstName: formValue.firstName.trim(),
      lastName: formValue.lastName.trim(),
      email: formValue.email.trim(),
      action: formValue.createCredentialsOrSendInvitation,
      groups: formValue.groups,
      configure_totp: formValue.configure_totp,
    };

    if (formValue.createCredentialsOrSendInvitation === 'createCredentials') {
      userDetails.password = formValue.password;
    }

    if (formValue.account_end_date) {
      userDetails.account_end_date = formValue.account_end_date;
    }
    setIsFormSubmit(true);
    await onSubmit(userDetails);
    setIsFormSubmit(false);
  };

  return (
    <>
      <UserForm
        type="add"
        form={form}
        alreadyDeactivatedModalShown={value => {
          setWarningModalShown(value);
        }}
        formSubmit={onFinish}
        isFormSubmit={isFormSubmit}
      />
      <Modal
        closable={false}
        visible={warningModalShown}
        onOk={() => {
          if (parentOrigin && window.top && window.top !== window) {
            window.top.postMessage(
              {
                type: 'redirect',
                url: `/admin/users?deactivatedUser=${getFieldValue('email')}`,
              },
              parentOrigin,
            );
          } else {
            history.push(`/users?deactivatedUser=${getFieldValue('email')}`);
          }
        }}
        okText={<FormattedMessage id="Global.confirm" />}
        okButtonProps={{
          shape: 'round',
          style: {
            width: '30%',
          },
        }}
        onCancel={() => setWarningModalShown(false)}
        cancelButtonProps={{
          id: 'close-modal',
          type: 'default',
          shape: 'round',
          style: {
            width: '30%',
          },
        }}
      >
        <Col span={20} offset={2}>
          <Row justify="center" style={{ marginBottom: '10px' }}>
            <WarningOutlined
              style={{ color: theme.palette.error, fontSize: '32px' }}
            />
          </Row>
          <Row justify="center" style={{ marginBottom: '-10px' }}>
            <p
              style={{ textAlign: 'center' }}
              data-testid="user-deactivated-message"
            >
              <FormattedMessage id="User.account.status" />
            </p>
          </Row>
        </Col>
      </Modal>
    </>
  );
};

export default AddUserForm;
